"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isInNetworkGroup;
var _lodash = require("lodash");
var _constants = _interopRequireDefault(require("../constants"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function isInNetworkGroup(group) {
  return (0, _lodash.get)(group, 'group_type') === _constants["default"].IN_NETWORK_GROUP_TYPE || (0, _lodash.get)(group, 'licensed') === true;
}